import {LoggerInterface} from './logger-interface';

export class LoggerManager {
  static loggers: Array<LoggerInterface> = [];

  static addLogger(loggerInstance: LoggerInterface): void {
    this.loggers.push(loggerInstance);
  }

  static log(msg: string): void {
    LoggerManager.loggers.forEach(loggerInstance => {
      loggerInstance.log(msg);
    });
  }
  static error(msg: string): void {
    LoggerManager.loggers.forEach(loggerInstance => {
      loggerInstance.error(msg);
    });
  }
  static debug(msg: string): void {
    LoggerManager.loggers.forEach(loggerInstance => {
      loggerInstance.debug(msg);
    });
  }
  static info(msg: string): void {
    LoggerManager.loggers.forEach(loggerInstance => {
      loggerInstance.info(msg);
    });
  }
  static warn(msg: string): void {
    LoggerManager.loggers.forEach(loggerInstance => {
      loggerInstance.warn(msg);
    });
  }
}
